import { render } from "./FarmListAddVillage.vue?vue&type=template&id=0f354ef5"
import script from "./FarmListAddVillage.vue?vue&type=script&lang=js"
export * from "./FarmListAddVillage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/area/windowOverlay/FarmListAddVillage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f354ef5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f354ef5', __exports__)) {
    api.reload('0f354ef5', __exports__)
  }
  
  module.hot.accept("./FarmListAddVillage.vue?vue&type=template&id=0f354ef5", () => {
    api.rerender('0f354ef5', render)
  })

}


export default __exports__